import React, { useCallback, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import RenderSelectBoxCell from "../../../common/RenderCell";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Button } from 'devextreme-react';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../common/GridLayout";
import {FormatPhoneNumber} from '../../../common/Utils'

function RelationshipLinkList(props) {
    let dataGrid = useRef(null);
    if (props.dataGrid) 
    {
        dataGrid = props.dataGrid;
    }
    const gridKey = props.gridKey;
    let accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    
    var url = "id/RelationShipLink/GetRelationshipLinks";
    var insertUrl = "id/RelationShipLink/InsertRelationshipLink";
    
    const dataSource = createStore({
        key: 'ROWID',
        loadParams:
        {
            IDMEMBERTYPE: function ()
            {
                return props.IdMemberType;
            },
            IDMASTERTYPE: function ()
            {
                return props.IdMasterType;
            },
            R_IDMASTER : function ()
            {
                return props.formFields.ROWID;
            }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
            };
        }
        /*,
        onInserted: function (e) {
            props.RefereshGrid();
        }*/
    });

    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    const rowInserting = (e) => {
        e.data['R_IDMASTER'] = props.formFields.ROWID;
        e.data['IDMASTERTYPE'] = props.IdMasterType;
        e.data['IDMEMBERTYPE'] = props.IdMemberType;
    };

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    };
    const deleteRecords = useCallback(() => {
        var deleteUrl = "id/RelationShipLink/DeleteRelationshipLink";
        let result = confirm("<i>Are your sure you want to delete selected record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedItemKeys[0],
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                    });
            }
        });
    }, [selectedItemKeys]);

    return (
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            id="gridContainer"
            // dataSource={dataSource}
            ref={dataGrid}
            selectedRowKeys={selectedItemKeys}
            showBorders={true}
            rowAlternationEnabled={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            onSelectionChanged={handleCellValueChanged}
            height={props.height || '100%'}
            key={"rowid"}
            onRowInserting={rowInserting}
            onContentReady={onContentReady}
        >
            <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
            >
                <ColumnChooserSearch
                    enabled={true}
                    editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
            />
            <Scrolling mode="standard" />
            <Selection mode="single" />
            <Export enabled={true} allowExportSelectedData={true} />
            <Editing
                mode="cell"
                refreshMode="repaint"
                allowUpdating={false}
                allowAdding={true}
            />
            <FilterRow visible={true} />
            
            {/* 
            <Column dataField="rowid" caption='rowid' visible={false} allowSorting={false} showInColumnChooser={false}   >
            </Column>  */}
            <Column dataField="MEMBERIDENTITYID" caption="Identity Id" allowSorting={!props.Editable}  allowEditing={props.Editable}
                editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/` + props.LookupUrl,
                        key: "id",
                        displayExpr: "name",
                        valueExpr: "id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.R_IDMEMBER,
                        sort: [{ selector: "name", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                setCellValue={(rowData, newValue) => {
                    rowData.R_IDMEMBER = newValue.value;
                    rowData.MEMBERIDENTITYID = newValue.text;
                }}
            >
            </Column>
            <Column dataField="MEMBERNAME" caption="Name" allowEditing={false} />
            <Column dataField="MEMBERTELEPHONE1" caption="Telephone" allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERTELEPHONE2" caption="Telephone 2" allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERWEBUSERNAME" caption="Web User Name" allowEditing={false} />
            <Column dataField="MEMBERADDRESS1" caption="Address" visible={false} allowEditing={false} />
            <Column dataField="MEMBERADDRESS2" caption="Address 2" visible={false} allowEditing={false} />
            <Column dataField="MEMBERADDRESSNAME" caption="Address Name" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCELLPHONE1" caption="Cell Phone" visible={false} allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERCELLPHONE2" caption="Cell Phone 2" visible={false} allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERCONTACTID" caption="Contact ID" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTNAME" caption="Contact Name" visible={false} allowEditing={false} />
            <Column dataField="CREATIONDATETIME" dataType="datetime" caption="Created By" visible={false} allowEditing={false} />
            <Column dataField="CREATIONUSERID" caption="Creation Date" visible={false} allowEditing={false} />
            <Column dataField="LASTUPDATEDATETIME" dataType="datetime" caption="Last Updated" visible={false} allowEditing={false} />
            <Column dataField="LASTUPDATEUSERID" caption="Last Updated by" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC1" caption="Contacts UDC_1" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC2" caption="Contacts UDC_2" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC3" caption="Contacts UDC_3" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC4" caption="Contacts UDC_4" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC5" caption="Contacts UDC_5" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC6" caption="Contacts UDC_6" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC7" caption="Contacts UDC_7" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC8" caption="Contacts UDC_8" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC9" caption="Contacts UDC_9" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCONTACTSUDC10" caption="Contacts UDC_10" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCITY" caption="City" visible={false} allowEditing={false} />
            <Column dataField="MEMBERSTATE" caption="State" visible={false} allowEditing={false} />
            <Column dataField="MEMBERZIP" caption="Zip" visible={false} allowEditing={false} />
            <Column dataField="MEMBERCOUNTRY" caption="Country" visible={false} allowEditing={false} />
            <Column dataField="MEMBERFAX1" caption="Fax" visible={false} allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERFAX2" caption="Fax 2" visible={false} allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERMODEM1" caption="Modem" visible={false} allowEditing={false} />
            <Column dataField="MEMBERMODEM2" caption="Modem 2" visible={false} allowEditing={false} />
            <Column dataField="MEMBERPAGER1" caption="Pager" visible={false} allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBERPAGER2" caption="Pager 2" visible={false} allowEditing={false} cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataField="MEMBEREMAILADDRESS1" caption="E-Mail" visible={false} allowEditing={false} />
            <Column dataField="MEMBEREMAILADDRESS2" caption="E-Mail 2" visible={false} allowEditing={false} />
            <Column dataField="MEMBERWEBSITEADDRESS1" caption="Web" visible={false} allowEditing={false} />
            <Column dataField="MEMBERWEBSITEADDRESS2" caption="Web 2" visible={false} allowEditing={false} />
            <Column dataField="MEMBERIDGROUP" caption="ID Group" visible={false} allowEditing={false} />
            <Column dataField="MEMBERIDSUBGROUP" caption="ID Sub Group" visible={false} allowEditing={false} />
            <Column dataField="MEMBERREFERENCE1" caption="Reference 1" visible={false} allowEditing={false} />
            <Column dataField="MEMBERREFERENCE2" caption="Reference 2" visible={false} allowEditing={false} />
            <Column dataField="MODULE" caption="Module" visible={false} allowEditing={false} />
            <Column dataField="RECORDTYPE" caption="Record type" visible={false} allowEditing={false} />
            <Column dataField="RECORDNUMBER" caption="Record #" visible={false} allowEditing={false} />
            <Column dataField="COMPANYID" caption="Company ID" visible={false} allowEditing={false} />
            <Toolbar>
                <Item
                    name="addRowButton"
                    visible={props.Editable}
                />
                <Item location="after">
                    <Button
                        onClick={deleteRecords}
                        icon="trash"
                        disabled={!selectedItemKeys.length}
                        visible={props.Editable}
                    />
                </Item>
                <Item location="after">
                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
                <Item name="exportButton" />
                <Item name="columnChooserButton" />
            </Toolbar>
        </DataGrid>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(RelationshipLinkList);